
import Vue, { PropType } from 'vue';
import Btn from '../button/Button.vue';

export default Vue.extend({
    components: {
        Btn
    },

    props: {
        closeOnClick: {
            type: Boolean as PropType<boolean>,
            default: false
        },
        ariaLabel: {
            type: String as PropType<string>,
            default: undefined
        }
    },

    data() {
        return {
            clicked: false
        };
    },

    methods: {
        onContentClicked() {
            if (this.closeOnClick) {
                this.clicked = false;
            }
        }
    }
});
